import { render, staticRenderFns } from "./ProjectClient.vue?vue&type=template&id=03259554&scoped=true&"
import script from "./ProjectClient.vue?vue&type=script&lang=js&"
export * from "./ProjectClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03259554",
  null
  
)

export default component.exports